import { useSecaoDuracao } from "./use-secao-duracao";
import { SecaoDuracaoView } from "./view-secao-duracao";
import type { SecaoDuracaoProps } from "./types-secao-duracao";

export function SecaoDuracao(props: SecaoDuracaoProps) {
  const vm = useSecaoDuracao(props);

  return <SecaoDuracaoView {...props} {...vm} />;
}

export type * from "./types-secao-duracao";
